import { render, staticRenderFns } from "./CustomerNotMatching.vue?vue&type=template&id=42485c51"
import script from "./CustomerNotMatching.vue?vue&type=script&lang=js"
export * from "./CustomerNotMatching.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports